import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { concatLatestFrom } from '@ngrx/operators';
import { courseActions } from '@app/store/course/actions/course.actions';
import { coursesActions } from '../actions/courses.actions';
import { selectLastParams } from '../selectors/courses.selector';

@Injectable()
export class CourseCoursesBridge {
    private readonly actions = inject(Actions);
    private readonly store = inject(Store);

    refreshOnMutation$ = createEffect(() => {
        return this.actions.pipe(
            ofType(courseActions.createCourseSuccess, courseActions.updateCourseSuccess, courseActions.deleteCourseSuccess),
            concatLatestFrom(() => this.store.select(selectLastParams)),
            map(([, lastParams]) => coursesActions.getCourses({ value: lastParams })),
        );
    });
}
